// extracted by mini-css-extract-plugin
export default {"btn":"btn__-5t9z","trim":"trim__HsX+i","txt-bg":"txt-bg__NzkJK","txtBg":"txt-bg__NzkJK","expanded":"expanded__KBjC3"};